module.exports = __webpack_public_path__ + "static/img/service-ac-citra-raya-18.f86c28f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kegiatan/service-ac-citra-raya-18.jpeg
// module id = TLhc
// module chunks = 0